define('shared/util/storageWrapper',[
    'shared/lib/RSVP'
], function(
    rsvp
){
    'use strict';
    var storeWrapper = {
        set: function(key, value) {
            var ret = sessionStorage.setItem(key, JSON.stringify(value));
            return rsvp.resolve(ret);
        },
        get: function(key) {
            var value;
            
            try{
                value = JSON.parse(sessionStorage.getItem(key));
            }
            catch(ex) {
                // usually there shouldn't be exception,
                // but because the JSON object injected by standalone.js is problematic
                // here we have it, thanks polyfill authors!
            }
            
            return rsvp.resolve(value);
        }
    };
    return storeWrapper;
});
